'use client';

import React from 'react';
import { cn } from '@/utils';
import { Icon } from '@/components/Icons/Icon';

export interface DegradedBannerProps {
  isSmUp: boolean;
}

/**
 * Banner shown when the avatar video couldn't load and the session fell back
 * to audio-only. Sits below the avatar window on desktop; fixed near the
 * bottom on mobile (where the avatar window is full-screen).
 */
export const DegradedBanner: React.FC<DegradedBannerProps> = ({ isSmUp }) => (
  <div
    role="status"
    aria-live="polite"
    className={cn(
      'mx-auto flex max-w-[629px] items-start gap-2 rounded-lg border border-accent-border-yellow bg-accent-surface-yellow px-4 py-3 text-left',
      {
        'fixed bottom-4 left-1/2 z-30 w-[calc(100%-1.5rem)] -translate-x-1/2': !isSmUp,
      },
    )}
  >
    <Icon name="Warning" size={20} className="mt-0.5 shrink-0 text-accent-status-yellow" />
    <p className="font-text text-body font-bold text-neutral-gray-700">
      Your video avatar couldn&apos;t be loaded due to a technical issue, so the simulation is
      continuing in audio-only mode.
    </p>
  </div>
);
